import React from 'react';
import PropTypes from 'prop-types';

import {Button} from "@material-ui/core";

function CustomButton({ loading, children, ...props }) {
  return (
    <Button variant="contained" {...props} disabled={loading}>
      {loading ? "Carregando..." : children}
    </Button>
  );
}

export default CustomButton;

CustomButton.defaultProps = {
  loading: false,
};

CustomButton.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.string.isRequired,
};
